import { useParams } from 'react-router';

export const useRequiredParams = <T extends Record<string, string | undefined>>() => {
  const params = useParams<T>();

  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- We want to assert the type of the params
  return params as T;
};
